<template>
  <div style="display: flex">
    <b-dropdown :text="tabs.find((x) => x.id === value).label" class="col-12">
      <b-dropdown-item v-for="tab in tabs" :key="tab.id" @click="select(tab)">
        {{ tab.label }}
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
export default {
  name: 'TabButtons',
  props: {
    value: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      tabs: [
        { id: 'general', label: 'General' },
        { id: 'integrations', label: 'Features' },
        { id: 'creditManagement', label: 'Credit Management' },
        { id: 'creditPolicy', label: 'Credit Policy' },
        { id: 'crisisContact', label: 'Crisis Contact' },
        { id: 'counselingCenter', label: 'Counseling Center' },
        { id: 'resources', label: 'Other Resources' },
        { id: 'primaryContact', label: 'Primary Contact' },
        { id: 'triage', label: 'Triage and Crisis Protocol' }
      ]
    };
  },
  methods: {
    select(tab) {
      this.$emit('input', tab.id);
    }
  }
};
</script>

<style lang="scss" scoped>
.dashboard-card {
  button {
    background-color: $white;
    flex: 1;
  }
  button.selected {
    background-color: $light-blue;
    color: $white;
    display: inline-block;
  }
}
</style>
